import { Component } from "@angular/core";

@Component({
    selector: 'app-p2p',
    templateUrl: './p2p.component.html',
    standalone: false
})

export class P2PComponent {

}
